module.exports = __webpack_public_path__ + "img/cayka-logo.5d55fd8e.png";